module.exports = __webpack_public_path__ + "static/img/address.360cafc3.png";